// /src/hooks/useTracking.js
import { useEffect, useRef } from 'react';

/** Scatta una sola volta quando lo scroll supera il 90% della pagina */
export const useScroll90 = (onTrigger) => {
  const firedRef = useRef(false);
  useEffect(() => {
    const handleScroll = () => {
      if (firedRef.current) return;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const percent = (scrollTop / docHeight) * 100;
      if (percent >= 90) {
        firedRef.current = true;
        onTrigger();
        window.removeEventListener('scroll', handleScroll);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [onTrigger]);
};

/** Scatta una sola volta quando l'elemento entra in viewport (IntersectionObserver) */
export const useViewOnce = (ref, onView, threshold = 0.4) => {
  const firedRef = useRef(false);
  useEffect(() => {
    if (!ref.current || firedRef.current) return;
    const node = ref.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !firedRef.current) {
            firedRef.current = true;
            onView();
            observer.disconnect();
          }
        });
      },
      { threshold }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref, onView, threshold]);
};
